export const EnrolmentTypes = {
	consumer: "CONSUMER",
	provider: "PROVIDER",
	provideOnBehalf: "PROVIDE_ON_BEHALF",
	consumeOnBehalf: "CONSUME_ON_BEHALF",
	provideOnBehalfOfPrincipal: "PROVIDE_ON_BEHALF_OF_PRINCIPAL",
	consumeOnBehalfOfPrincipal: "CONSUME_ON_BEHALF_OF_PRINCIPAL",
};

export const EnrolmentRoles = {
	ADMIN: "admin",
	PARTICIPANT: "participant",
};

export const EnrolmentSteps = {
	[EnrolmentRoles.PARTICIPANT]: {
		choosePersonas: "Choose Personas",
		configureIssuance: "Configure Issuance",
		reviewAndConfirm: "Review & Confirm",

		getEnrolmentSteps(useCase) {
			const { choosePersonas, configureIssuance, reviewAndConfirm } =
				this;

			if (useCase?.enableETR) {
				return [choosePersonas, configureIssuance, reviewAndConfirm];
			}

			return [choosePersonas, reviewAndConfirm];
		},
	},
	[EnrolmentRoles.ADMIN]: {
		chooseUseCase: "Choose Use Case",
		choosePersonas: "Choose Personas",
		reviewAndConfirm: "Review & Confirm",

		getEnrolmentSteps(useCase) {
			const { chooseUseCase, choosePersonas, reviewAndConfirm } = this;

			return [chooseUseCase, choosePersonas, reviewAndConfirm];
		},
	},
};
